import React, { Fragment, useEffect, useState } from 'react';
import { RootState } from 'ReduxStore/store';
import {  Link, Redirect, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import milestone from 'Assets/img/svg/icons/milestones.svg';
import Header from 'Components/Header/Header';
import { categories, icons } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';
import {  getMilestoneByCategories } from 'ReduxStore/milestones/Action';
import { milestoneUseStyles } from './milestones.style';
import ClipLoader from 'react-spinners/ClipLoader';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Background from 'Components/Reusable/Background/Background';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import { changeIdentities, shuffleCategories, shuffleItems } from 'Helpers';
import { Routes } from 'Utils';
import { GetAllKids } from 'ReduxStore/children/Action';
import Error from 'Components/Timeline/Error';

interface RouteParams {
	id: string;
	milestoneId:string;
}
const ListMilestones = (props: any) => {
	const classes = milestoneUseStyles();
	const dispatch = useDispatch();
	const params = useParams<RouteParams>();
	const matches = useMediaQuery('(max-width:768px)');
	const history = useHistory()
	const [loading, setLoading] = useState<boolean>(false)
	useEffect(() => {
		setLoading(true)
		dispatch(getMilestoneByCategories(params.id));
		dispatch(GetAllKids());
		setLoading(false)
		
	}, []);



	const milestones = useSelector((state: RootState) => state.milestones.milestone);
	const upcoming = milestones && milestones.filter((milestone:any) =>  milestone?.MilestoneAchieveds?.length == 0);
	const childName = localStorage.getItem('currentChild')
	const children = useSelector((state: RootState) => state.children.children);
	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));
	const errors = useSelector((state:RootState) => state.milestones.error)
	// eslint-disable-next-line no-console
	console.log(errors,"are here")

	const milestoneLink = (id:any) => {
		return history.push(`/upcoming-milestones/exercises/${params.id}&${id}`)
	}
	const goBackToMilestones = () => {
		// return history.push(Routes.MilestoneCategories)
		return window.open(Routes.MilestoneCategories,'_self')
	}
	return (
		<Fragment>
			<div className="">
				<Header />
				<Background backgroundColor="#FFE6D9"  height={milestones ? (milestones?.length > 4 ? 'auto' : '100vh') :  '100vh'} >
					<OverlapCard
						image={milestone}
						subheading={`Check out upcoming milestones for ${childName} `}
						common={{ margin: '-5rem auto 2rem', width: '80%' }}
						rounded
						buttonColor="#7FD6DD"
						buttonText="RETURN TO MILESTONES"
						onClick={goBackToMilestones}
						upper
					>
						{milestones && milestones.length > 0 ? (
							<div>
								<ul className={classes.listItems}>
									{milestones.map((milestone,i) => (
										<div key={milestone.id} className="my-3">
														<MenuCard
															url={`exercise/${milestone.id}`}
															image={shuffleCategories(categories) }
															type={ changeIdentities(milestone.title,child?.fullName,child?.gender) }
															common={{ width: '100%', height: '80.74px' }}
															budge={ milestone.MilestoneAchieveds && milestone?.MilestoneAchieveds?.length > 0 ?  categories[0].achievedbudge : categories[0].budge}
															isUpcoming
															onClick={() => milestoneLink(milestone && milestone.id)}
														/>
										</div>
									))}
								</ul>
								<ul
									style={{
										display: 'flex',
										listStyleType: 'none',
										flexWrap: 'nowrap',
										justifyContent: 'center',
										margin: '1rem 0 0',
										padding: '0',
									}}
								>
									{icons.map((icon, i) => (
										<li key={i}>
											<img src={icon} alt="" />
										</li>
									))}
								</ul>
							</div>
						) : (
							<div>
								{
								errors ? (
									<Error errors={errors}/>
								) : (
									<div className={classes.loading}>
										<h4>Wait a moment ...</h4>
										<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
									</div>
								)
								}
							</div>
							
						)}
						
					</OverlapCard>
					
				</Background>
			</div>
		</Fragment>
	);
};

export default ListMilestones;
